export const COLUMN_NAMES = {
  AMOUNT: 'amount',
  NAME: 'dealname',
  STAGE: 'dealstage',
  AMOUNT_IN_HOME_CURRENCY: 'amount_in_home_currency',
  CLOSE_DATE: 'closedate',
  DEAL_NAME: 'dealname',
  NEXT_STEP: 'hs_next_step',
  DEAL_STAGE: 'dealstage',
  DEAL_FORECAST_CATEGORY: 'hs_manual_forecast_category',
  DEAL_LAST_UPDATED: 'notes_last_updated',
  DEAL_TAGS: 'hs_tag_ids',
  DEAL_SCORE: 'hs_deal_score',
  FORECAST_AMOUNT: 'hs_forecast_amount',
  FORECAST_PROBABILITY: 'hs_forecast_probability',
  DEAL_STAGE_PROBABILITY: 'hs_deal_stage_probability',
  WEIGHTING_AMOUNT: 'hs_projected_amount'
};